import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import baseMessage from './components/baseMessage.vue'
import { useRoute } from 'vue-router'
import { signInRecordDetail } from '@/api/yuntuSales/visitToSign'

export default /*#__PURE__*/_defineComponent({
  __name: 'detail',
  setup(__props) {

const route = useRoute()
const data = ref({})
// 获取详情
const fetch = () => {
  if (route.query.id) {
    signInRecordDetail({ id: route.query.id }).then((res) => {
      data.value = res.data
    })
  }
}
onMounted(() => {
  fetch()
})

return (_ctx: any,_cache: any) => {
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_CosViewContent, null, {
            default: _withCtx(() => [
              _createVNode(baseMessage, { data: data.value }, null, 8, ["data"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})